import React from "react";
import Head from "next/head";
import Header from "../components/newHeader/Header";
import Footer from "../components/newFooter";
import styles from "./tos.module.scss";

export default function CustomerFaq() {
  return (
    <div>
      <Head>
        {/*  Facebook tags  */}
        <meta name="og:title" content="Terms & Conditions" key="title" />
        <meta name="og:type" content="website" key="type" />
        <meta
          name="og:url"
          content={`${process.env.NEXT_PUBLIC_ROOT_URL}/tos`}
          key="url"
        />
        <meta
          name="og:description"
          content="Review the Terms & Conditions that govern use of Mawoo Pets for all users, including customers and breeders."
        />
        <meta name="og:locale" content="en_US" key="locale" />
        {/*  standard tags  */}
        <title>Terms & Conditions</title>

        <meta
          name="description"
          content="Review the Terms & Conditions that govern use of Mawoo Pets for all users, including customers and breeders."
        />
        <meta
          name="robots"
          content={
            process.env.NEXT_PUBLIC_ROOT_URL === "https://www.mawoopets.com"
              ? "index, follow"
              : "noindex, nofollow"
          }
        />
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_ROOT_URL}/tos`}
        />
      </Head>
      <Header />
      <main className={styles.main}>
        <h1 className={styles.title}>Terms & Conditions</h1>
        <p className="p1">
          Welcome to the Mawoo Pets website (the &ldquo;<strong>Website</strong>
          &rdquo;), operated by Mawoo Pets Ltd. and Mawoo Pets LLC
          (collectively, &ldquo;<strong>Mawoo Pets</strong>&rdquo;, &ldquo;
          <strong>we</strong>&rdquo;, &ldquo;<strong>us</strong>&rdquo; or
          &ldquo;<strong>our</strong>&rdquo;). These terms and conditions (the
          &ldquo;<strong>Terms</strong>&rdquo;) are an agreement between you
          (&ldquo;<strong>you</strong>&rdquo; or &ldquo;<strong>your</strong>
          &rdquo;) and Mawoo Pets governing your access and use of the Website
          and any other services provided by us (collectively, the &ldquo;
          <strong>Services</strong>&rdquo;).
        </p>
        <p className="p1">
          These Terms apply to (i) users who are breeders (&ldquo;
          <strong>Breeders</strong>&rdquo;) that use our Services to sell
          puppies; and (ii) users who are customers (&ldquo;
          <strong>Customers</strong>&rdquo;) that buy using our Services
          (collectively, &ldquo;<strong>Users</strong>&rdquo;). Unless otherwise
          stated, these Terms apply to all Users of the Services. Certain
          provisions may only apply to Breeders or Customers, as specifically
          noted in these Terms.
        </p>
        <p className="p1">
          In order to use our Services, you must agree to the Terms contained
          herein, the privacy policy (&ldquo;<strong>Privacy Policy</strong>
          &rdquo;) and any other policies or guidelines posted on our Website.
          The Terms incorporate the Privacy Policy referenced in Section 8 below
          and any other policies or guidelines posted on the Website. Please
          read the Terms carefully before accessing and using the Services.
        </p>
        <p className="p2">
          By accessing and using our Services, you are confirming that you are
          authorized to agree to and that you are accepting and agreeing to be
          bound by these Terms. If you are accepting these Terms as authorized
          representative on behalf of a company or other entity, you represent
          and warrant that you have the authority to bind such entity to these
          Terms and by accepting these Terms, you are doing so on behalf of such
          entity (in which case the terms &ldquo;you&rdquo; or
          &ldquo;User&rdquo; shall refer to such entity and to the authorized
          representative in his or her capacity as authorized representative).
          We reserve the right to request proof from such authorized
          representative that he or she has the authority to bind such entity to
          these Terms.
        </p>
        <p className="p1">
          BY ACCESSING AND USING THE SERVICES, YOU ACCEPT, WITHOUT LIMITATION,
          ALL OF THE TERMS AS INDICATED HEREIN. If you ARE NOT AUTHORIZED TO
          AGREE OR do not agree to these terms, you are not permitted to access
          or use the services.
        </p>
        <p className="p3">
          These Terms are in effect as of the date of acceptance as noted above.
          We reserve the right to add, remove, modify or otherwise change any
          part of these Terms at any time without prior notice. Changes will be
          effective when the changed Terms are posted on the Website or
          otherwise made available to you. It is your responsibility to consult
          the Terms from time to time to ensure that you are up to date on any
          changes which may affect you. Your continued access and use of the
          Services after the changes to the Terms take effect will constitute
          your acceptance of such changes. If you do not agree the changes, you
          are required to immediately discontinue use of the Services.
        </p>
        <ol className={styles.mainList}>
          <li className="li4">
            <strong>OVERVIEW OF OUR SERVICES</strong>
          </li>
        </ol>
        <p className="p1">
          We make our Services available to Breeders, including family,
          registered, and non-registered breeders to:
        </p>
        <ul className="ul1">
          <li className="li5">
            showcase and share information with potential Customers, including
            breeder&rsquo;s history, certifications, puppy and breeding parent
            profiles, registrations, vaccination records, microchip
            certificates, and health certificates;
          </li>
          <li className="li5">
            connect with potential Customers looking to purchase puppies;
          </li>
          <li className="li5">
            manage puppy applications submitted by potential Customers;
          </li>
          <li className="li5">
            facilitate online and video chats with potential Customers;
          </li>
          <li className="li5">
            schedule site visits with potential Customers;
          </li>
          <li className="li5">securely transact with Customers; and</li>
          <li className="li5">coordinate puppy pick-up or delivery.</li>
        </ul>
        <p className="p5">Customers may use our Services to:</p>
        <ul className="ul1">
          <li className="li5">
            browse the profiles of puppies available for sale and access
            information about their Breeders;
          </li>
          <li className="li5">
            communicate with Breeders via direct messaging and video chats;
          </li>
          <li className="li5">
            submit puppy applications to Breeders to purchase a puppy;
          </li>
          <li className="li5">schedule site visits with Breeders;</li>
          <li className="li5">securely transact with Breeders; and</li>
          <li className="li5">arrange for puppy pick-up or delivery.</li>
        </ul>
        <p className="p4">
          Breeders are responsible to communicate with Customers looking to buy
          a puppy, to answer the Customer&rsquo;s questions before, during, and
          after the puppy has been delivered to the Customer, and address
          Customer&rsquo;s concerns as they may arise. Breeders (and not Mawoo
          Pets) set the prices for the puppies and the shipment costs, if
          applicable.&nbsp;
        </p>
        <ol start={2} className="ol1">
          <li className="li4">
            <strong>USER REGISTRATION, ACCOUNT AND PASSWORD</strong>
          </li>
        </ol>
        <p className="p1">
          In order for you to access and use the Services, you must sign up for
          a User account on the Website and complete the registration process.
          You must be at least <span className="s2">XX</span> years old to
          REGISTER OR use the Services. Any access to, or use of, the Services
          by anyone under 18 years of age is expressly prohibited. By accessing
          or using the Services, you represent and warrant that you are 18 years
          of age or older.
        </p>
        <p className="p1">
          In signing up for a User account, you agree to submit true, up-to-date
          and complete information and promptly update such information should
          it change. You are solely responsible for the accuracy of the
          information provided to us in your User account. To learn more about
          the registration process and how your information is used, please see
          our Privacy Policy referenced in Section 8 of these Terms
        </p>
        <p className="p1">
          As a Breeder signing up for a Breeder account, we will contact you to
          discuss your registration, verify your breeder status and information
          provided on the Breeder&rsquo;s application, and obtain any additional
          information reasonably required to assess the health, safety, and
          socialization of puppies. Once we approve your registration as a
          Breeder, at our sole discretion, you will gain access to your Breeder
          account and may start using our Services. We reserve the right to
          re-examine and verify your breeder status after your initial
          registration to ensure you continue to meet our Service standards
          applicable to Breeders. According, we may require that you provide
          additional information reasonably required to re-assess your breeder
          status.
        </p>
        <p className="p2">
          You must keep your User account and password confidential and must not
          disclose your User account and password to any third party. You agree
          to immediately notify us of any unauthorized use of your User account,
          password, or any other breach of security known to you or that becomes
          known to you. If you believe someone has accessed your User account
          without your authorization, it is your responsibility to inform us and
          set up a new password.
        </p>
        <p className="p2">
          You are responsible for any and all activities, without limitation,
          which occur under your User account and password and will be liable
          for any unauthorized use or misuse of your User account and password
          by someone other than you.
        </p>
        <p className="p4">
          We reserve the right to refuse, suspend or terminate your access to
          your User account or the Services in our sole discretion at any time.
        </p>
        <ol start={3} className="ol1">
          <li className="li4">
            <strong>OWNERSHIP RIGHTS</strong>
          </li>
        </ol>
        <p className="p5">
          Any and all information (excluding User Content, as defined in Section
          4 of these Terms), content, reports, data, databases, graphics,
          interfaces, designs, web pages, text, files, software, services,
          logos, icons, trade names, audio or video clips, underlying HTML,
          software codes, meta-tags, trade-marks, service marks, patents,
          copyrights, trade secrets and other intellectual property rights
          contained in, associated with or available through our Services
          (collectively, &ldquo;<strong>Mawoo Pets</strong>{" "}
          <strong>Content</strong>&rdquo;) including the manner in which the
          Mawoo Pets Content is presented or appears and all information
          relating thereto, are the property of Mawoo Pets, or used under
          license by Mawoo Pets, or Mawoo Pets is authorized to use or reproduce
          the Mawoo Pets Content by the holder of all rights thereto.
        </p>
        <p className="p1">
          Mawoo Pets Content is protected by copyright, trademark or other
          applicable laws. You are hereby authorized to display Mawoo Pets
          Content on your computer in a web browser as part of the expected and
          ordinary use of the Services. You may not copy or use Mawoo Pets
          Content in any other manner or for any purpose. In particular, you may
          not:<span className="Apple-converted-space">&nbsp; &nbsp;</span>
        </p>
        <ol className="ol2">
          <li className="li1">
            copy, sell, reproduce, distribute, retransmit, publish, modify,
            display or prepare derivative works based on, re-post, or otherwise
            use any of the Mawoo Pets Content or underlying ownership rights or
            copyrights without the prior written consent of Mawoo Pets; or
          </li>
          <li className="li1">
            remove or alter any visible or non-visible identification, marks,
            notices, or disclaimers.
          </li>
        </ol>
        <p className="p5">
          Your access to or use of the Services should not be construed as
          granting, by implication or otherwise, any license to use the Mawoo
          Pets Content without our prior written consent or the consent of the
          third party owner.
        </p>
        <ol start={4} className="ol1">
          <li className="li5">
            <span className="s3">
              <strong>USER CONTENT</strong>
            </span>
          </li>
        </ol>
        <p className="p5">
          All information, data, databases, graphics, video, text, files,
          transaction documents and other materials provided, submitted or
          uploaded by you through your User account or otherwise provided to us
          (the &ldquo;<strong>User Content</strong>&rdquo;) will remain your
          exclusive property. Except in the case of any inaccuracies caused by
          Mawoo Pets, you are solely responsible for the accuracy and
          completeness of any of your User Content provided to us, and the
          compliance of such User Content with applicable laws. You agree not to
          submit, upload, post or otherwise provide any User Content that is
          false or misleading in any respect. You represent and warrant that you
          have all necessary rights, consents or approvals to the User Content
          you provide to us (including any puppy health certificates and
          vaccination records, in case you provide information through a Breeder
          account) and that you are not infringing or violating any third
          party&rsquo;s rights by providing such content to us.
        </p>
        <p className="p5">
          We may, but have no obligation to, monitor, edit, or remove User
          Content that we determine in our sole discretion to be unlawful,
          offensive, threatening, libelous, defamatory, obscene or otherwise
          objectionable or violates any third party&rsquo;s intellectual
          property or these Terms.
        </p>
        <p className="p5">
          By providing your User Content to us, you hereby grant us a
          non-exclusive, worldwide, perpetual, irrevocable, royalty-free,
          transferable, sub-licensable right to make use of your User Content in
          connection with providing, managing and administering the Services
          provided to you. For clarity, we may use, reproduce, archive,
          transmit, create derivative works, cache, and otherwise use your User
          Content for the purpose of providing the Services as specified under
          these Terms and if applicable, in accordance our Privacy Policy
          referenced in Section 8 of these Terms.
        </p>
        <p className="p5">
          You also grant us a perpetual, royalty-free, sub-licensable and
          transferable license to use aggregated and anonymized User Content for
          research, marketing and analytics purposes. You acknowledge and agree
          that aggregated and anonymized User Content may not be deleted from
          our systems until it has served the purpose for which it was
          collected. We will not use User Content for any purpose other than as
          specified in these Terms or in accordance with our Privacy Policy
          referenced in Section 8 of these Terms.
        </p>
        <p className="p5">
          We shall have no liability whatsoever for the loss or corruption of
          User Content or for the failure of any backups of same for any reason
          whatsoever, including as a result of the failure of the equipment,
          software or communications services of Internet, hosting or other
          service providers. As User Content is your property, you are solely
          responsible for insuring that you retain a copy of all User Content
          and backing up same in a manner that suits your requirements should
          you require any such backups.
        </p>
        <p className="p5">
          You may delete your User Content individually or all at once by
          deleting your User account at any time. When you delete your User
          Content, it is no longer visible to other users, however it may
          continue to exist on our systems:
        </p>
        <ol className="ol2">
          <li className="li5">
            for a maximum of 90 days, after which time it will be permanently
            deleted;
          </li>
          <li className="li5">
            where it has been used or otherwise shared by other users in
            accordance with these Terms, and they have not deleted it; or
          </li>
          <li className="li5">
            for a period of time longer than 90 days, as we may deem fit in our
            sole discretion, for the purpose of investigating violations of
            these Terms or complying with our legal obligations.
          </li>
        </ol>
        <p className="p5">
          In the case of User Content containing personal information, we will
          delete such content that is our possession in accordance with our
          Privacy Policy referenced in Section 8 of these Terms and our
          obligations under applicable laws.
        </p>
        <p className="p4">
          If you choose to delete your User account, you will no longer be able
          to use the Services. However, within 90 days of your deletion request,
          you may re-activate your User account by logging back in.&nbsp;
        </p>
        <ol className={styles.mainList} start={5}>
          <li className="li4">
            <strong>PERMITTED USES</strong>
          </li>
        </ol>
        <p className="p6">
          We authorize you to access and use the Services solely for the
          purposes pursuant to these Terms. You may also access or download
          messages, data, information or other materials from the Website or
          that are otherwise made available to you, provided that such materials
          are not modified and you retain all copyright and other proprietary
          notices contained in such materials. You agree to be fully responsible
          for any consequences resulting from your use of such materials. You
          may not access or use the Services in any manner or for any other
          purpose other than the purposes permitted in these Terms.
        </p>
        <p className="p5">
          You agree that to use the Services for lawful purposes only. You are
          responsible for ensuring that you are complying with all applicable
          laws when using the Services, including with regards to the possession
          and sale of any puppy purchased through the Website.
        </p>
        <p className="p4">
          You acknowledge and agree that we may investigate any alleged or
          potential violations of law or these Terms and in doing so, may
          co-operate with law enforcement authorities. We reserve the right to
          seek all available remedies for violations of these Terms.
        </p>
        <ol className={styles.mainList} start={6}>
          <li className="li4">
            <strong>PROHIBITED USES</strong>
          </li>
        </ol>
        <p className="p7">
          Without limitation, you will not access or use (or allow others to
          access or use) our Services:
        </p>

        <ol className="ol2" type="i">
          <li className="li7">
            for any purpose or in any manner that is unlawful, harmful or
            otherwise objectionable, including but not limited to any conduct
            that would constitute a criminal offence or incur civil liability,
            infringe others&rsquo; intellectual property or other rights,
            disclose private or personal matters concerning any person;
          </li>

          <li className="li7">
            to contact or invite contact with other Users for any reason other
            than the purpose for which you receive the user&rsquo;s contact
            information or solicit sales outside of our Services;
          </li>

          <li className="li7">
            in any manner which could interfere with or disrupt our Services or
            any services, system resources, accounts, servers of networks
            connected to or accessible through the Website or affiliated or
            linked sites, including attempting to interfere with the access of
            any other user, host or network, including without limitation,
            overloading, disabling, engaging in &ldquo;denial of service&rdquo;
            attacks, &ldquo;spamming&rdquo;, &ldquo;crashing&rdquo;, or
            &ldquo;mail-bombing&rdquo; such sites or disobeying any
            requirements, procedures, policies or regulations of networks
            connected to such sites;
          </li>

          <li className="li7">
            to use, store, share, host, copy, distribute, display, publish,
            transmit or send content that is or may be deemed offensive,
            inflammatory, hateful, defamatory, discriminatory, obscene, abusive,
            invasive of privacy, harmful to others, or otherwise objectionable;
          </li>

          <li className="li7">
            to upload, e-mail, post, make available, provide access, or
            otherwise transmit through our Services any material that contains
            software viruses, worms, &ldquo;Trojan Horses&rdquo;, or any other
            computer code, files or programs designed to interrupt, destroy,
            alter, or limit the functionality of any computer software or
            hardware or telecommunications equipment;
          </li>

          <li className="li7">
            to hack or circumvent any system feature including any
            experimentation, inspection, decrypting, decompiling, disassembling
            or reverse engineering any portion of our Services for any reason;
          </li>

          <li className="li7">
            to obtain or attempt to obtain any material or information through
            any means not intentionally made available to you through our
            Services;
          </li>

          <li className="li7">
            to modify, copy, distribute, transmit, display, perform, reproduce,
            license, create derivative works from, transfer, or sell the
            Services, Mawoo Pets Content or any part thereof;
          </li>

          <li className="li7">
            to use or attempt to use another user&rsquo;s account without
            authorization, or create or use a false identity;
          </li>

          <li className="li7">
            to collect, use, store or disclose personal information about other
            users without the consent of the owner of the information, if
            prohibited by applicable law; or
          </li>

          <li className="li4">
            violate, or encourage the violation of, any applicable local,
            provincial or federal law and any regulations.
          </li>
        </ol>
        <ol className={styles.mainList} start={7}>
          <li className="li4">
            <strong>TRANSACTIONS AND PAYMENTS </strong>
          </li>
        </ol>
        <p className="p4">
          Customer interested in purchasing a puppy is directed to submit a
          puppy application to the selected Breeder for review and approval via
          our Services. Once the Breeder approves the Customer’s application to
          purchase a particular puppy, the Customer is directed to pay a deposit
          (in US or Canadian dollars, as specified).
        </p>
        <p className="p4">
          The deposit payments are final and non-refundable. However, if the
          puppy is not available or unfit for sale, the deposit will be refunded
          to the customer within 1-3 business days.
        </p>
        <p className="p4">
          In case the Breeder and Customer agree to proceed via shipping, the
          shipping fee will be agreed upon and paid by the Customer before
          delivery. Mawoo Pets does not offer shipping services. However, we
          work with a network of commercial travel provides to provide
          transportation of puppies from Breeders to Customers. All shipping
          details, such as shipping provider, cost and delivery address, will be
          confirmed with both Breeder and Customer prior to proceeding with
          delivery. If a Customer does not accept delivery or cancels puppy
          order for any reason after the puppy has been shipped by Breeder, the
          full payment made by the Customer will be forfeited.
        </p>
        <p className="p4">
          Breeder is solely responsible for any taxes, fees, and duties
          (collectively, <b>“Taxes”</b>) imposed by governmental entities
          related to payment transactions facilitated through our Services. To
          clarify, Breeder will collect from the Customer and remit any
          applicable Taxes associated with every sale of a puppy using our
          Services.
        </p>
        <p className="p4">
          Breeder is responsible for all representations, warranties or
          guarantees that Breeder directly provides to Customers about the
          puppies or makes available through the Services. This includes
          advising the Customers of Breeder’s Health Guarantee and procedures
          before any purchase. For a Customer to claim any monetary refunds due
          to a health-related issue, the puppy purchased by the Customer must be
          covered by a Breeder Health Guarantee, as disclosed to the Customer at
          the time of purchase, and the puppy’s health issues or conditions must
          be covered in the terms of the Health Guarantee. Customers are
          required to have a licensed veterinarian perform a complete health
          examination on their puppy within 3 days of receiving the puppy, and
          to share any issues identified by the veterinarian promptly with Mawoo
          Pets. If the Customer is unable to provide such evidence, the Customer
          forfeits the right to any monetary refunds, even if the puppy’s health
          condition is otherwise covered by the Health Guarantee.
        </p>
        <p className="p4">
          We do not charge the Breeder any fees for accessing or using our
          Services. We charge the Customer that purchases a puppy using our
          Services a one-time fee (the purchase price does not include Taxes or
          transaction processing fees charged by our payment provider). We may
          change this fee amount at any time, in which case we will update these
          Terms and notify Breeders at the time of transaction.
        </p>
        <p className="p4">
          Payments made by Customers are processed through our third party
          payment provider Stripe, Inc. All terms and conditions relating to
          administration of payments for the Services are subject to{" "}
          <a href="https://stripe.com/privacy">
            <span className="s4">https://stripe.com/privacy</span>
          </a>{" "}
          and{" "}
          <a href="https://stripe.com/legal">
            <span className="s4">https://stripe.com/legal</span>
          </a>
          .{" "}
        </p>
        <p className="p4">
          Customers and Breeders may also be required to accept additional terms
          and conditions in relation to the use of that service (including
          paying applicable transaction processing fees). We cannot accept, and
          hereby exclude to the fullest extent permitted by applicable law, any
          liability arising out of or in connection with your use of such third
          party payment provider.{" "}
        </p>
        <p className="p4">
          Customers can also apply for financing using Afterpay or Terrace
          Finance for the payment of Services. All such financing and payments
          are subject to either Afterpay or Terrace Finance Terms of Service and
          Privacy Policy, viewable at:{" "}
          <a href=" https://www.afterpay.com/en-US/terms-of-service">
            <span className="s4">
              https://www.afterpay.com/en-US/terms-of-service
            </span>
          </a>{" "}
          and{" "}
          <a href="https://terracefinance.com/terms-of-service/">
            <span className="s4">
              https://terracefinance.com/terms-of-service/
            </span>
          </a>
          . We hereby exclude to the fullest extent permitted by applicable law,
          any liability arising out of or in connection with your use of such
          third party financing option.
        </p>

        <ol className={styles.mainList} start={8}>
          <li className="li4">
            <strong>PERSONAL INFORMATION</strong>
          </li>
        </ol>
        <p className="p5">
          The collection, use, storage and disclosure of your personal
          information in connection with your access and use of our Services
          shall be governed by our{" "}
          <a href={`${process.env.NEXT_PUBLIC_ROOT_URL}/policy`}>
            <span className="s8"> Privacy Policy </span>
          </a>{" "}
          (the &ldquo;<strong>Privacy Policy</strong>&rdquo;), as amended from
          time to time. The Privacy Policy is hereby incorporated into these
          Terms.
        </p>
        <p className="p4">
          By agreeing these Terms, you acknowledge that you have reviewed the
          Privacy Policy and consent to Mawoo Pets&rsquo;s collection, use,
          storage and disclosure of your personal information in accordance with
          the Privacy Policy.&nbsp;
        </p>
        <ol className={styles.mainList} start={9}>
          <li className="li4">
            <strong>COOKIES</strong>
          </li>
        </ol>
        <p className="p4">
          The Website uses "cookies", a technology that saves information on
          your computer to permit the Website to recognize future visits using
          that computer. Cookies enhance the convenience and use of the Website.
          For example, the information provided through cookies is used to
          recognize you as a previous user of the Website, to track your
          activity within the Website in order to respond to your needs, to
          offer personalized content and information for your use, and to
          otherwise facilitate your Website experience. You may choose to
          decline cookies if your browser permits, but doing so may affect your
          use of the Website and your ability to access certain features of the
          Website. If you do not agree with the Website&rsquo;s use of cookies
          and your browser does not enable you to decline cookies, then you must
          not use the Website.
        </p>
        <ol className={styles.mainList} start={10}>
          <li className="li4">
            <strong>Third Party sites </strong>
          </li>
        </ol>
        <p className="p5">
          The Services, emails, or other information we may send or make
          available to you may contain materials from third parties. Third party
          links on our Website may direct you to third party sites that are not
          affiliated with us. We are not responsible for examining or evaluating
          the content or accuracy of these third party sites, and we do not
          warrant and will not have any liability or responsibility for any
          third party materials or sites, or for any other materials, products,
          or services of third parties. We are not liable for any harm or
          damages related to the purchase or use of goods, services, resources,
          content, or any other transactions made in connection with any third
          party sites.
        </p>
        <p className="p5">
          You acknowledge and agree that we are not responsible for the
          availability of such third party sites and such sites do not imply any
          endorsement by or any affiliation with us of the hyperlinked sites.
          Your access and use of such third party sites, including any
          information, material, products and services therein, is solely at
          your own risk.
        </p>
        <p className="p4">
          We encourage that you review carefully the third party's policies and
          practices and make sure you understand them before you access third
          party sites or engage in any transaction. Complaints, claims,
          concerns, or questions regarding third party products or services
          should be directed to the third party.
        </p>
        <ol className={styles.mainList} start={11}>
          <li className="li4">
            <strong>OPTIONAL TOOLS</strong>
          </li>
        </ol>
        <p className="p5">
          We may provide you with access to third party tools over which we
          neither monitor nor have any control nor input. You acknowledge and
          agree that we provide access to such tools &ldquo;as is&rdquo; and
          &ldquo;as available&rdquo; without any warranties, representations, or
          conditions of any kind and without any endorsement. We shall have no
          liability whatsoever arising from or relating to your use of optional
          third party tools.
        </p>
        <p className="p5">
          Any use by you of optional tools offered through our Services is
          entirely at your own risk and discretion and you should ensure that
          you are familiar with and approve of the terms on which tools are
          provided by the relevant third party provider(s).
        </p>
        <p className="p4">
          Some of the third party tools you may use through our Services are
          offered by Google (for messaging and video calls between Users) and{" "}
          <a href="https://www.klaviyo.com/legal">
            <span className="s4">Klaviyo, Inc</span>
          </a>
          <span className="s5">.</span> (for email communications we send to
          Users). We may also, in the future, offer new features through the
          Services (including, the release of new tools and resources). Such new
          features shall also be subject to these Terms.
        </p>
        <ol className={styles.mainList} start={12}>
          <li className="li4">
            <strong>Disclaimer</strong>
          </li>
        </ol>
        <p className="p5">
          YOU EXPRESSLY UNDERSTAND AND AGREE THAT the services made available
          through THE WEBSITE OR OTHER MEANS, ANY MAWOO PETS CONTENT AND THIRD
          PARTY CONTENT ARE PROVIDED ON AN &ldquo;AS IS&rdquo; AND &ldquo;AS
          AVAILABLE&rdquo; BASIS. THERE ARE NO, AND MAWOO PETS DISCLAIMS ANY,
          REPRESENTATIONS, WARRANTIES AND CONDITIONS OF ANY NATURE OR KIND
          WHATSOEVER, WHETHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE,
          INCLUDING BUT NOT LIMITED TO, THE IMPLIED REPRESENTATION, WARRANTIES
          OR CONDITIONS OF MERCHANTABILITY, AVAILABILITY OF THE SERVICES,
          SERVICE QUALITY, ACCURACY, FITNESS FOR A PARTICULAR PURPOSE AND
          NON-INFRINGEMENT.
        </p>
        <p className="p4">
          THE SERVICES MAY INCLUDE INACCURACIES OR TYPOGRAPHICAL ERRORS. MAWOO
          PETS MAKES NO REPRESENTATIONS, WARRANTIES OR CONDITIONS ABOUT THE
          SECURITY, PRIVACY, RELIABILITY, TIMELINESS, CORRECTNESS OR ACCURACY OF
          THE SERVICES, MAWOO PETS CONTENT OR THE THIRD PARTY CONTENT MADE
          AVAILABLE THROUGH THE WEBSITE FOR ANY PURPOSE WHATSOEVER.
        </p>
        <ol className={styles.mainList} start={13}>
          <li className="li4">
            <strong>Limitation of liability</strong>
          </li>
        </ol>
        <p className="p10">
          under no circumstances, WHETHER IN CONTRACT OR TORT (INCLUDING
          NEGLIGENCE), AS A RESULT OF BREACH OF WARRANTY, STRICT LIABILITY,
          INDEMNITY OR UNDER ANY OTHER THEORY OF LIABILITY whatsoever, shall
          MAWOO PETS, its directors, officers, SHAREHOLDERS, employees, agents,
          REPRESENTATIVES, CONTRACTORS, CONSULTANTS, AFFILIATES, licensors OR
          SERVICE PROVIDERS (collectively, THE &ldquo;
          <strong>MAWOO PETS Parties</strong>&rdquo;) be liable for any loss or
          damages whatsoever, including any DAMAGES CHARACTERIZED AS: (A) LOSS
          OF PROFITS, LOSS OF INCOME, LOSS OF REVENUES, LOSS OF ANTICIPATED
          SALES, LOSS OF OPPORTUNITIES, BUSINESS INTERRUPTION or FAILURE TO
          REALIZE UNEXPECTED SAVINGS; OR (B) direct, indirect, incidental,
          special, punitive, consequential or exemplary losses or damages, of
          any nature whatsoever, including but not limited to damages arising
          from or in connection with:
        </p>
        <p className="p11">&nbsp;</p>
        <ol className="ol2" type="i">
          <li className="li7">
            <span className="s3">
              YOUR access to, use or reliance made on THE services, THE MAWOO
              PETS CONTENT OR ANY THIRD PARTY CONTENT;{" "}
            </span>
          </li>
          <li className="li7">
            <span className="s3">
              your inability to access or use any contents THROUGH the WEBSITE
              OR other MEANS PROVIDED TO ACCESS THE services;{" "}
            </span>
          </li>
          <li className="li7">
            <span className="s3">
              any information provided in connection with THE services
              (including through the WEBSITE, or any website or its contents
              linked or linking to the WEBSITE);{" "}
            </span>
          </li>
          <li className="li1">
            <span className="s3">
              any delivery, hosting or ancillary services or facilities of third
              party providers used by MAWOO PETS; OR
            </span>
          </li>
          <li className="li7">
            <span className="s3">
              ANY OTHER MATTERS RELATING TO THE SERVICES, THE MAWOO PETS CONTENT
              OR ANY THIRD PARTY CONTENT.{" "}
            </span>
          </li>
        </ol>
        <p className="p11">&nbsp;</p>
        <p className="p7">
          EVEN IF THE MAWOO PETS PARTIES HAVE BEEN ADVISED OF THE POSSIBILITY OF
          SUCH DAMAGES IN ADVANCE.
        </p>
        <p className="p8">&nbsp;</p>
        <p className="p4">
          CERTAIN JURISDICTIONS MAY NOT ALLOW LIMITATIONS ON OR EXCLUSIONS OF
          EXPRESS OR IMPLIED REPRESENTATIONS, WARRANTIES OR CONDITIONS OR THE
          EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO
          YOU, SOME OR ALL OF THE DISCLAIMERS, EXCLUSIONS OR LIMITATIONS
          PROVIDED FOR IN THESE TERMS OF USE MAY NOT APPLY TO YOU, AND YOU MAY
          HAVE ADDITIONAL RIGHTS AS PROVIDED BY LAW.
        </p>
        <ol className={styles.mainList} start={14}>
          <li className="li4">
            <strong>Indemnification</strong>
          </li>
        </ol>
        <p className="p7">You are responsible and may be held liable for:</p>
        <p className="p8">&nbsp;</p>
        <ol className="ol2" type="i">
          <li className="li1">
            any breach of your representations or obligations under these Terms
            and for the consequences of such breach, including any resulting
            loss or damage incurred by Mawoo Pets Parties or any other party;
          </li>
          <li className="li1">
            any losses incurred by Mawoo Pets Parties or any other party due to
            the access to or use of the Services (including access to or use of
            the Website by another party using your User account and password);
          </li>
          <li className="li1">
            any and all activities that occur under your User account; and
          </li>
          <li className="li1">any and all your actions and omissions.</li>
        </ol>
        <p className="p8">&nbsp;</p>
        <p className="p7">
          You hereby agree to indemnify, defend and hold harmless the Mawoo Pets
          Parties from and against any claims, losses, judgments, damages, costs
          and expenses (including, without limitation, reasonable legal fees)
          made by any third party due to or arising out of:
        </p>
        <p className="p8">&nbsp;</p>
        <ol className="ol2" type="i">
          <li className="li1">
            your use or access to the Services, the Mawoo Pets Content or third
            party content (including use or access to the Website through your
            User account by you or any person);
          </li>
          <li className="li1">
            violation by you or any person using your User account of these
            Terms or the policies they incorporate;
          </li>
          <li className="li1">
            your violation of any applicable laws or the rights of a third
            party; and
          </li>
          <li className="li1">
            any User Content that you upload or otherwise submit on, through, or
            in connection with the Services.
            <span className="Apple-converted-space">&nbsp; &nbsp;</span>
          </li>
        </ol>
        <p className="p4">
          You agree to assist and co-operate as fully as reasonably required by
          Mawoo Pets Parties in the defense of any such claim or demand.
        </p>
        <ol className={styles.mainList} start={15}>
          <li className="li4">
            <strong>RELEASE</strong>
          </li>
        </ol>
        <p className="p4">
          If you have a dispute with one or more users of our Services, you
          release Mawoo Pets Parties from claims, demands, and damages (actual
          and consequential) of every kind and nature, known and unknown,
          suspected and unsuspected, disclosed and undisclosed, arising out of,
          resulting from or in any way connected with such disputes.
        </p>
        <ol className={styles.mainList} start={16}>
          <li className="li4">
            <strong>Termination</strong>
          </li>
        </ol>
        <p className="p5">
          These Terms are effective until terminated or replaced by us, with or
          without cause, in our sole and exclusive discretion. We reserve the
          right to suspend or terminate your User account and/or your access to
          the Services (or any portion of the Services) in the event that you
          fail to comply with these Terms or for any other reason whatsoever,
          with or without cause. If we terminate your User account and/or access
          to the Services (or any portion of the Services), we will notify you
          and you may not try to access the Services again without our prior
          written approval. Any such termination shall be in addition and
          without prejudice to such rights and remedies as may be available to
          us, including injunction and other civil or equitable remedies or
          relief. We shall not be liable to you or to any third party in any way
          for such actions.
          <span className="Apple-converted-space">&nbsp; &nbsp;</span>
        </p>
        <p className="p5">
          If these Terms or your permission to access or use the Services are
          suspended or terminated for any reason, then (i) these Terms will
          nevertheless continue to apply and be binding upon you, in respect of
          your prior access to or use of the Services and anything connected
          with, relating to or arising therefrom; and (ii) we may continue to
          use and disclose your personal information in accordance with the
          Privacy Policy referenced in Section 8 of these Terms.
        </p>
        <p className="p4">
          Upon the termination of these Terms by us, we will delete or destroy
          your User Content that is then in our possession and that is no longer
          required as we determine in our sole discretion or, in the case of
          personal information, in accordance with our Privacy Policy referenced
          in Section 8 of these Terms and our obligations under applicable laws.
        </p>
        <ol className={styles.mainList} start={17}>
          <li className="li4">
            <strong>NO WARRANTIES</strong>
          </li>
        </ol>
        <p className="p4">
          Statements and information about the Services are made for
          informational purposes only and do not constitute representations,
          warranties or conditions, express or implied, statutory or otherwise
          concerning such Services. All features, content, specifications,
          products and services described or depicted on the Website are subject
          to change at any time without notice. The inclusion of any products or
          services on the Website at a particular time does not imply or warrant
          that these products or services will be available at any time.
        </p>
        <ol className={styles.mainList} start={18}>
          <li className="li4">
            <strong>No waiver</strong>
          </li>
        </ol>
        <p className="p4">
          We will not be considered to have waived any of our rights or remedies
          described in these Terms unless the waiver is in writing and signed by
          us against whom such waiver is invoked. No delay or omission by us in
          exercising our rights or remedies will impair or be construed as a
          waiver. Any single or partial exercise of a right or remedy will not
          preclude further exercise of any other right or remedy. Our failure to
          enforce the strict performance of any provision of these Terms will
          not constitute a waiver for our right to subsequently enforce such
          provision or any other provisions of these Terms.
        </p>
        <ol className={styles.mainList} start={19}>
          <li className="li4">
            <strong>right to modify or discontinue SERVICES</strong>
          </li>
        </ol>
        <p className="p4">
          We reserve the right at any time to modify or discontinue, temporarily
          or permanently, the Services (or any portion of the Services) and to
          restrict or prohibit access to the Services or parts thereof, without
          notice to you. You agree that we shall not be liable to you or to any
          third party for any modification, suspension or discontinuance of such
          Services. We reserve the right, in our sole discretion, to correct any
          errors or omissions in any portion of the Services at any time without
          notice, but confirm that we have no obligation to do so.
          <span className="Apple-converted-space">&nbsp; &nbsp;</span>
        </p>
        <ol className={styles.mainList} start={20}>
          <li className="li4">
            <strong>Applicable law</strong>
          </li>
        </ol>
        <p className="p4">
          These Terms are governed by the laws of the Province of Ontario and
          the laws of Canada applicable therein. The courts of the Province of
          Ontario shall have exclusive jurisdiction over any dispute arising
          from, connected with, or relating to these Terms, and you irrevocably
          submit and consent to the exclusive jurisdiction of those courts in
          respect of all such disputes.
        </p>
        <ol className={styles.mainList} start={21}>
          <li className="li4">
            <strong>Entire agreement</strong>
          </li>
        </ol>
        <p className="p4">
          These Terms, including the Privacy Policy and any other policies or
          guidelines posted on the Website, constitute the entire agreement
          between Mawoo Pets and the User relating to the Services provided by
          Mawoo Pets to the User and supersede any prior understandings or
          agreements (whether oral or written), claims, representations, and
          understandings of the parties with respect to such subject matter.
          These Terms may not be amended or modified except in writing or by
          making such amendments or modifications available or giving notice of
          them on the Website or by sending or otherwise giving notice of such
          amendments to the User.
        </p>
        <ol className={styles.mainList} start={22}>
          <li className="li4">
            <strong>Severability </strong>
          </li>
        </ol>
        <p className="p4">
          If any provision of these Terms is held by a court of competent
          jurisdiction to be contrary to law, or otherwise is invalid or
          unenforceable, then such provision shall be construed, as nearly as
          possible, to reflect the intentions of the parties, with the other
          provisions of these Terms remaining in full force and effect.
        </p>
        <ol className={styles.mainList} start={23}>
          <li className="li4">
            <strong>Survival</strong>
          </li>
        </ol>
        <p className="p4">
          The provisions of Sections 3 (Ownership Rights), 4 (Breeder Content),
          8 (Personal Information), 10 (Third Party Sites), 11 (Optional Tools),
          12 (Disclaimer), 13 (Limitation of Liability), 14 (Indemnification),
          15 (Release), 16 (Termination), 17 (No Warranties), 18 (No Waiver), 20
          (Applicable Law), 21 (Entire Agreement), 23 (Survival) and 26
          (Interpretation) shall remain in full force and effect after the
          termination or expiry of these Terms.
        </p>
        <ol className={styles.mainList} start={24}>
          <li className="li4">
            <strong>NO Assignment</strong>
          </li>
        </ol>
        <p className="p4">
          You may not assign or otherwise transfer your rights, duties or
          obligations under these Terms.
        </p>
        <ol className={styles.mainList} start={25}>
          <li className="li4">
            <strong>RIGHTS</strong>
          </li>
        </ol>
        <p className="p4">
          All rights not expressly granted herein are reserved.
        </p>
        <ol className={styles.mainList} start={26}>
          <li className="li4">
            <strong>INTERPRETATION</strong>
          </li>
        </ol>
        <p className="p5">
          In the Terms, unless something in the subject matter or context is
          inconsistent therewith or unless otherwise herein provided:
        </p>
        <ul className="ul1">
          <li className="li5">
            a reference to any applicable law is to that applicable law as now
            enacted or as the same may from time to time be amended, re-enacted
            or replaced;
          </li>
          <li className="li5">
            the term &ldquo;provision&rdquo; includes terms, conditions,
            covenants, agreements, representations, warranties and other
            provisions;
          </li>
          <li className="li5">
            words or abbreviations that have well known technical, industry or
            trade meanings are used herein in accordance with their recognized
            meanings;
          </li>
          <li className="li5">
            the terms &ldquo;herein&rdquo;, &ldquo;hereunder&rdquo; and similar
            expressions refer to these Terms and not to any particular section
            or other portion hereof;
          </li>
          <li className="li5">
            where the word &ldquo;including&rdquo; or &ldquo;includes&rdquo; is
            used in these Terms, it means &ldquo;including (or includes) without
            limitation&rdquo;; and
          </li>
          <li className="li4">
            words importing the singular include the plural and vice versa and
            words importing gender include all genders.
          </li>
        </ul>
        <ol className={styles.mainList} start={27}>
          <li className="li4">
            <strong>Contact</strong>
          </li>
        </ol>
        <p className="p7">
          Questions, comments or any reports of violations of these Terms should
          be sent to email to{" "}
          <a href="mailto:info@mawoopets.com">
            <span className="s4">info@mawoopets.com</span>
          </a>
          .&nbsp;
        </p>
      </main>
      <Footer />
    </div>
  );
}
